
import React from 'react';
import { Grid } from '@mui/material';
import Section from '../section';

const LinkedInPost = ({ title, postIds = [] }) => {
  const ids = Array.isArray(postIds) ? postIds : [postIds];

  return (
    <Section title={title}>
      <Grid container spacing={4} justifyContent="center">
        {ids.map((postId, index) => (
          <Grid item size={{ xs: 12, md: 6 }} key={index} display="flex" justifyContent="center">
            <iframe
              src={`https://www.linkedin.com/embed/feed/update/urn:li:share:${postId}?collapsed=1`}
              height="645"
              width="100%"
              frameBorder="0"
              allowFullScreen=""
              title={`LinkedIn Post ${index + 1}`}
              style={{ maxWidth: '504px' }}
            ></iframe>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default LinkedInPost;
